import AuthFlowsContainer, {
  AuthFlowsContainerProps
} from "features/sign-up/components/containers/AuthFlowsContainer";

import useLastSignOutWasForced from "../../../../hooks/useLastSignOutWasForced";

export type SignInCardFlowsContainerProps = {
  linkToSignUp: string;
  linkToPasswordReset: string;
};

const forcedLogOutHeaderMessage = {
  message:
    "You were automatically logged out. This might be because your browser storage was cleared or because you logged out of another tab. Please log back in!"
};

export default function SignInCardFlowsContainer(
  props: AuthFlowsContainerProps<SignInCardFlowsContainerProps>
) {
  const lastSignOutWasForced = useLastSignOutWasForced();

  const headerMessage = lastSignOutWasForced
    ? forcedLogOutHeaderMessage
    : undefined;

  return (
    <AuthFlowsContainer
      action="Log in"
      defaultErrorMessage={headerMessage}
      {...props}
    />
  );
}
